import { FC } from 'react'
import { DetailField, DetailFields, DetailPanel } from 'app/components'
import { EsusEnvioListItem } from '../../../core/_models'
import { formatarData } from '../../../core/_formato'

type Props = {
  envio?: EsusEnvioListItem
  isLoading?: boolean
}

/**
 * Linha expandida da listagem de envios: os dados de apoio que saíram das colunas para a tabela
 * caber sem rolagem horizontal. Tudo já vem na própria linha (sem requisição extra).
 */
export const EsusEnvioExpandedRow: FC<Props> = ({ envio, isLoading }) => {
  if (!isLoading && !envio) return null
  const tentativas = envio?.tentativas ?? 0

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes do envio…'>
      {envio && (
        <DetailFields>
          <DetailField label='Unidade' value={envio.unidadeNome} />
          <DetailField
            label='Data do atendimento'
            value={envio.atendimentoData ? formatarData(envio.atendimentoData) : undefined}
            // A ficha de cadastro (FCI) é por cidadão e não tem atendimento (F7a).
            emptyLabel='Sem atendimento'
          />
          <DetailField
            label='Tentativas'
            value={`${tentativas} ${tentativas === 1 ? 'tentativa' : 'tentativas'}`}
          />
          <DetailField label='UUID da ficha' value={envio.uuidFicha} wide />
        </DetailFields>
      )}
    </DetailPanel>
  )
}
